module.exports = __webpack_public_path__ + "img/house.354fd36d.svg";